const TopNoticeBar = ( props ) => {
    return (
        props?.active &&
        <div
            className="sb-noticebar-ctn"
            data-type={ props?.type ? props?.type : 'default' }
        >
            <span className="sb-noticebar-heading">
                { props?.heading }
                { props?.actionText &&
                    <strong
                        onClick={ () => {
                            props?.actionClick &&
                                props?.actionClick()
                        }}
                    >
                        {props?.actionText}
                    </strong>
                }
            </span>
            {
                (props?.close !== false || props?.close === undefined) &&
                <div
                    className='sb-cls-ctn sb-modal-cls'
                    onClick={ () => {
                        props?.onClose &&
                            props.onClose()
                    }}
                >
                </div>
            }

        </div>
    )
}

export default TopNoticeBar;